<template>
  <div>
    <h4>You are[ {{getTestState}} ] s [{{ getUserData }}] + in home.</h4>
  </div>
</template> 
<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return{

    }
  },
  computed: {
    ...mapGetters({
      getUserData: "auth/getUserData",
      getTestState: "main/getTestState"
    })
  },
  mounted() {
 
    // this.localData = this.$store.state.auth.userdata;
    // this.testState = this.$store.state.main.testState;
  }
};
</script> 